// DO NOT EDIT -- generated from fs/services/llm-tool/autoconfigure.proto

import { LlmModel } from './llm.proto';
import * as pages from '../../api/pages';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';

export namespace AutoconfigurePublic {

  export const GenerateAttributeSuggestionsEndpoint = "/grpc/llm_tool.AutoconfigurePublic/GenerateAttributeSuggestions";
  export function GenerateAttributeSuggestions(sender: (req: GenerateAttributeSuggestionsRequest, endpoint: string) => Promise<GenerateAttributeSuggestionsResponse>, req: GenerateAttributeSuggestionsRequest): { promise: () => Promise<GenerateAttributeSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateAttributeSuggestionsEndpoint),
      endpoint: GenerateAttributeSuggestionsEndpoint
    };
  }

  export const DescribeAttributeSuggestionsEndpoint = "/grpc/llm_tool.AutoconfigurePublic/DescribeAttributeSuggestions";
  export function DescribeAttributeSuggestions(sender: (req: DescribeAttributeSuggestionsRequest, endpoint: string) => Promise<DescribeAttributeSuggestionsResponse>, req: DescribeAttributeSuggestionsRequest): { promise: () => Promise<DescribeAttributeSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DescribeAttributeSuggestionsEndpoint),
      endpoint: DescribeAttributeSuggestionsEndpoint
    };
  }

  export const KickstartSuggestedElementsEndpoint = "/grpc/llm_tool.AutoconfigurePublic/KickstartSuggestedElements";
  /**
   * KickstartSuggestedElements starts suggested element discovery for a
   * specified org
   */
  export function KickstartSuggestedElements(sender: (req: KickstartSuggestedElementsRequest, endpoint: string) => Promise<{}>, req: KickstartSuggestedElementsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, KickstartSuggestedElementsEndpoint),
      endpoint: KickstartSuggestedElementsEndpoint
    };
  }

  export const GetSuggestedGenerationStatusEndpoint = "/grpc/llm_tool.AutoconfigurePublic/GetSuggestedGenerationStatus";
  export function GetSuggestedGenerationStatus(sender: (req: GetSuggestedGenerationStatusRequest, endpoint: string) => Promise<GetSuggestedGenerationStatusResponse>, req: GetSuggestedGenerationStatusRequest): { promise: () => Promise<GetSuggestedGenerationStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSuggestedGenerationStatusEndpoint),
      endpoint: GetSuggestedGenerationStatusEndpoint
    };
  }

  export const SetPageSuggestionEndpoint = "/grpc/llm_tool.AutoconfigurePublic/SetPageSuggestion";
  export function SetPageSuggestion(sender: (req: SetPageSuggestionRequest, endpoint: string) => Promise<SetPageSuggestionResponse>, req: SetPageSuggestionRequest): { promise: () => Promise<SetPageSuggestionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetPageSuggestionEndpoint),
      endpoint: SetPageSuggestionEndpoint
    };
  }

  export const GetAllPageSuggestionsEndpoint = "/grpc/llm_tool.AutoconfigurePublic/GetAllPageSuggestions";
  export function GetAllPageSuggestions(sender: (req: GetAllPageSuggestionsRequest, endpoint: string) => Promise<GetAllPageSuggestionsResponse>, req: GetAllPageSuggestionsRequest): { promise: () => Promise<GetAllPageSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllPageSuggestionsEndpoint),
      endpoint: GetAllPageSuggestionsEndpoint
    };
  }

  export const GetPageSuggestionEndpoint = "/grpc/llm_tool.AutoconfigurePublic/GetPageSuggestion";
  export function GetPageSuggestion(sender: (req: GetPageSuggestionRequest, endpoint: string) => Promise<GetPageSuggestionResponse>, req: GetPageSuggestionRequest): { promise: () => Promise<GetPageSuggestionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageSuggestionEndpoint),
      endpoint: GetPageSuggestionEndpoint
    };
  }

  export const UpdatePageSuggestionsStatusesEndpoint = "/grpc/llm_tool.AutoconfigurePublic/UpdatePageSuggestionsStatuses";
  export function UpdatePageSuggestionsStatuses(sender: (req: UpdatePageSuggestionsStatusesRequest, endpoint: string) => Promise<UpdatePageSuggestionsStatusesResponse>, req: UpdatePageSuggestionsStatusesRequest): { promise: () => Promise<UpdatePageSuggestionsStatusesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePageSuggestionsStatusesEndpoint),
      endpoint: UpdatePageSuggestionsStatusesEndpoint
    };
  }

  export const GetPageSuggestionsByIdsEndpoint = "/grpc/llm_tool.AutoconfigurePublic/GetPageSuggestionsByIds";
  export function GetPageSuggestionsByIds(sender: (req: GetPageSuggestionsByIdsRequest, endpoint: string) => Promise<GetPageSuggestionsByIdsResponse>, req: GetPageSuggestionsByIdsRequest): { promise: () => Promise<GetPageSuggestionsByIdsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageSuggestionsByIdsEndpoint),
      endpoint: GetPageSuggestionsByIdsEndpoint
    };
  }

  export const GetPageSuggestionsThumbnailUrlsEndpoint = "/grpc/llm_tool.AutoconfigurePublic/GetPageSuggestionsThumbnailUrls";
  export function GetPageSuggestionsThumbnailUrls(sender: (req: GetPageSuggestionsThumbnailUrlsRequest, endpoint: string) => Promise<GetPageSuggestionsThumbnailUrlsResponse>, req: GetPageSuggestionsThumbnailUrlsRequest): { promise: () => Promise<GetPageSuggestionsThumbnailUrlsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageSuggestionsThumbnailUrlsEndpoint),
      endpoint: GetPageSuggestionsThumbnailUrlsEndpoint
    };
  }
}

export namespace Autoconfigure {

  export const GenerateSuggestedElementEndpoint = "/grpc/llm_tool.Autoconfigure/GenerateSuggestedElement";
  export function GenerateSuggestedElement(sender: (req: GenerateSuggestedElementRequest, endpoint: string) => Promise<GenerateSuggestedElementResponse>, req: GenerateSuggestedElementRequest): { promise: () => Promise<GenerateSuggestedElementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateSuggestedElementEndpoint),
      endpoint: GenerateSuggestedElementEndpoint
    };
  }

  export const SetSuggestedGenerationStatusEndpoint = "/grpc/llm_tool.Autoconfigure/SetSuggestedGenerationStatus";
  export function SetSuggestedGenerationStatus(sender: (req: SetSuggestedGenerationStatusRequest, endpoint: string) => Promise<{}>, req: SetSuggestedGenerationStatusRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetSuggestedGenerationStatusEndpoint),
      endpoint: SetSuggestedGenerationStatusEndpoint
    };
  }

  export const GetSuggestedGenerationStatusEndpoint = "/grpc/llm_tool.Autoconfigure/GetSuggestedGenerationStatus";
  export function GetSuggestedGenerationStatus(sender: (req: GetSuggestedGenerationStatusRequest, endpoint: string) => Promise<GetSuggestedGenerationStatusResponse>, req: GetSuggestedGenerationStatusRequest): { promise: () => Promise<GetSuggestedGenerationStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSuggestedGenerationStatusEndpoint),
      endpoint: GetSuggestedGenerationStatusEndpoint
    };
  }

  export const KickstartSuggestedElementsForAllOrgsEndpoint = "/grpc/llm_tool.Autoconfigure/KickstartSuggestedElementsForAllOrgs";
  export function KickstartSuggestedElementsForAllOrgs(sender: (req: KickstartSuggestedElementsForAllOrgsRequest, endpoint: string) => Promise<{}>, req: KickstartSuggestedElementsForAllOrgsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, KickstartSuggestedElementsForAllOrgsEndpoint),
      endpoint: KickstartSuggestedElementsForAllOrgsEndpoint
    };
  }

  export const CronSuggestedElementsEndpoint = "/grpc/llm_tool.Autoconfigure/CronSuggestedElements";
  export function CronSuggestedElements(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CronSuggestedElementsEndpoint),
      endpoint: CronSuggestedElementsEndpoint
    };
  }

  export const HandleElementGenerationEndpoint = "/grpc/llm_tool.Autoconfigure/HandleElementGeneration";
  export function HandleElementGeneration(sender: (req: HandleElementGenerationRequest, endpoint: string) => Promise<HandleElementGenerationResponse>, req: HandleElementGenerationRequest): { promise: () => Promise<HandleElementGenerationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, HandleElementGenerationEndpoint),
      endpoint: HandleElementGenerationEndpoint
    };
  }

  export const KickstartSuggestionsForAllOrgsEndpoint = "/grpc/llm_tool.Autoconfigure/KickstartSuggestionsForAllOrgs";
  /** KickstartSuggestionsForAllOrgs starts suggested elements and attribute suggestions for all orgs */
  export function KickstartSuggestionsForAllOrgs(sender: (req: KickstartSuggestionsForAllOrgsRequest, endpoint: string) => Promise<{}>, req: KickstartSuggestionsForAllOrgsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, KickstartSuggestionsForAllOrgsEndpoint),
      endpoint: KickstartSuggestionsForAllOrgsEndpoint
    };
  }

  export const HandleAttributeGenerationEndpoint = "/grpc/llm_tool.Autoconfigure/HandleAttributeGeneration";
  export function HandleAttributeGeneration(sender: (req: HandleAttributeGenerationRequest, endpoint: string) => Promise<HandleAttributeGenerationResponse>, req: HandleAttributeGenerationRequest): { promise: () => Promise<HandleAttributeGenerationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, HandleAttributeGenerationEndpoint),
      endpoint: HandleAttributeGenerationEndpoint
    };
  }

  export const HandleMLPageSpecSuggestionsEndpoint = "/grpc/llm_tool.Autoconfigure/HandleMLPageSpecSuggestions";
  export function HandleMLPageSpecSuggestions(sender: (req: HandleMLPageSpecSuggestionsRequest, endpoint: string) => Promise<HandleMLPageSpecSuggestionsResponse>, req: HandleMLPageSpecSuggestionsRequest): { promise: () => Promise<HandleMLPageSpecSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, HandleMLPageSpecSuggestionsEndpoint),
      endpoint: HandleMLPageSpecSuggestionsEndpoint
    };
  }

  export const SetAttributeSuggestionEndpoint = "/grpc/llm_tool.Autoconfigure/SetAttributeSuggestion";
  export function SetAttributeSuggestion(sender: (req: SetAttributeSuggestionRequest, endpoint: string) => Promise<SetAttributeSuggestionResponse>, req: SetAttributeSuggestionRequest): { promise: () => Promise<SetAttributeSuggestionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetAttributeSuggestionEndpoint),
      endpoint: SetAttributeSuggestionEndpoint
    };
  }

  export const GetAllAttributeSuggestionsEndpoint = "/grpc/llm_tool.Autoconfigure/GetAllAttributeSuggestions";
  export function GetAllAttributeSuggestions(sender: (req: GetAllAttributeSuggestionsRequest, endpoint: string) => Promise<GetAllAttributeSuggestionsResponse>, req: GetAllAttributeSuggestionsRequest): { promise: () => Promise<GetAllAttributeSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllAttributeSuggestionsEndpoint),
      endpoint: GetAllAttributeSuggestionsEndpoint
    };
  }

  export const GeneratePageSuggestionsEndpoint = "/grpc/llm_tool.Autoconfigure/GeneratePageSuggestions";
  export function GeneratePageSuggestions(sender: (req: GeneratePageSuggestionsRequest, endpoint: string) => Promise<GeneratePageSuggestionsResponse>, req: GeneratePageSuggestionsRequest): { promise: () => Promise<GeneratePageSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GeneratePageSuggestionsEndpoint),
      endpoint: GeneratePageSuggestionsEndpoint
    };
  }

  export const HandlePageGenerationEndpoint = "/grpc/llm_tool.Autoconfigure/HandlePageGeneration";
  export function HandlePageGeneration(sender: (req: HandlePageGenerationRequest, endpoint: string) => Promise<HandlePageGenerationResponse>, req: HandlePageGenerationRequest): { promise: () => Promise<HandlePageGenerationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, HandlePageGenerationEndpoint),
      endpoint: HandlePageGenerationEndpoint
    };
  }

  export const KickstartPageGenerationForAllOrgsEndpoint = "/grpc/llm_tool.Autoconfigure/KickstartPageGenerationForAllOrgs";
  export function KickstartPageGenerationForAllOrgs(sender: (req: KickstartPageGenerationForAllOrgsRequest, endpoint: string) => Promise<{}>, req: KickstartPageGenerationForAllOrgsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, KickstartPageGenerationForAllOrgsEndpoint),
      endpoint: KickstartPageGenerationForAllOrgsEndpoint
    };
  }

  export const CronPageGenerationEndpoint = "/grpc/llm_tool.Autoconfigure/CronPageGeneration";
  export function CronPageGeneration(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CronPageGenerationEndpoint),
      endpoint: CronPageGenerationEndpoint
    };
  }

  export const GenerateSessionPageSuggestionsEndpoint = "/grpc/llm_tool.Autoconfigure/GenerateSessionPageSuggestions";
  export function GenerateSessionPageSuggestions(sender: (req: GenerateSessionPageSuggestionsRequest, endpoint: string) => Promise<GenerateSessionPageSuggestionsResponse>, req: GenerateSessionPageSuggestionsRequest): { promise: () => Promise<GenerateSessionPageSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateSessionPageSuggestionsEndpoint),
      endpoint: GenerateSessionPageSuggestionsEndpoint
    };
  }

  export const RefreshPageSuggestionsThumbnailsEndpoint = "/grpc/llm_tool.Autoconfigure/RefreshPageSuggestionsThumbnails";
  export function RefreshPageSuggestionsThumbnails(sender: (req: RefreshPageSuggestionsThumbnailsRequest, endpoint: string) => Promise<RefreshPageSuggestionsThumbnailsResponse>, req: RefreshPageSuggestionsThumbnailsRequest): { promise: () => Promise<RefreshPageSuggestionsThumbnailsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RefreshPageSuggestionsThumbnailsEndpoint),
      endpoint: RefreshPageSuggestionsThumbnailsEndpoint
    };
  }
}

export interface GenerateAttributeSuggestionsRequest {
  orgId: string;
  /** number of pages to sample from, if unset, default to 10. max of 25 */
  numPages: number;
  /** number of urls to sample from per page, if unset, default to 1. max of 10 */
  numUrlsPerPage: number;
  /** time range to sample from, if unset, default to 7 days */
  timeRange: segment.TimeRange | null;
  /** PageDefIds to exclude */
  excludedPageDefIds: protobuf.int64[];
}

export interface GenerateAttributeSuggestionsResponse {
  suggestions: AttributeSuggestion[];
}

export interface AttributeSuggestion {
  id: string;
  name: string;
  priority: Priority;
  /** total occurrences across all events */
  totalEventOccurrences: protobuf.int64;
  /** number of unique session pageIds (not pageDefIds) that the attribute occurred on */
  totalPageOccurrences: protobuf.int64;
  totalUniqueValues: protobuf.int64;
  /** does not include all occurrences, max of 10 */
  sampleValues: AttributeSuggestion.SampleValue[];
  capturedAtStartTime: protobuf.timestamp | null;
  capturedAtEndTime: protobuf.timestamp | null;
}

export namespace AttributeSuggestion {
  export interface SampleValue {
    value: string;
    userId: protobuf.int64;
    sessionId: protobuf.int64;
    pageId: protobuf.int64;
    /** from start of page in millis */
    occurredOffset: protobuf.int64;
    url: string;
    pageDefId: protobuf.int64;
    fullCss: string;
    isNonsense: boolean;
    targetText: string;
    playbackUrl: string;
    capturedAt: protobuf.timestamp | null;
  }
}

export enum Priority {
  PRIORITY_UNSET = 0,
  PRIORITY_LOW = 1,
  PRIORITY_MEDIUM = 2,
  PRIORITY_HIGH = 3
}

export interface DescribeAttributeSuggestionsRequest {
  suggestions: AttributeSuggestion[];
}

export interface DescribeAttributeSuggestionsResponse {
  response: string;
}

export interface InitiatorVolume {
  pageId: protobuf.int64;
}

export interface InitiatorErrors {
  pageId: protobuf.int64;
}

export interface InitiatorProgressIndicators {
  pageId: protobuf.int64;
}

export interface InitiatorRecentMLPages {
  numPages: protobuf.int64;
  recentDays: protobuf.int64;
}

export interface InitiatorSvg {
  pageId: protobuf.int64;
}

export interface InitiatorPowerUsers {
  totalSessionTime: protobuf.int64;
  averageSessionTime: protobuf.int64;
}

export interface InitiatorSuggestiveErrors {
}

export interface InitiatorSuggestiveProgressIndicators {
}

export enum SelectorTrim {
  /**
   * whatever method we determine is the best will be the default mode
   * (currently BASIC)
   */
  TRIM_DEFAULT = 0,
  /** apply basic cleanup such as removing body tags and duplicate parts */
  TRIM_BASIC = 1,
  /** do not modify the existing selectors at all */
  TRIM_NONE = 4,
  /** use LLM directly to determine best selector */
  TRIM_EXTRACT = 3,
  /** use TrimSelector from the backend */
  TRIM_AI_BACKEND = 5
}

export enum Method {
  METHOD_INVALID = 0,
  METHOD_SELECTOR_ONLY = 1,
  METHOD_MULTIMODAL = 2,
  METHOD_MOBILE = 3
}

export interface HandleMLPageSpecSuggestionsRequest {
  orgId: string;
  /** number of days to sample from, if unset, default to 7 */
  recentDays: protobuf.int64;
  /** whether to auto-approve the spec suggestion. */
  commit: boolean;
}

export interface HandleMLPageSpecSuggestionsResponse {
  suggestion: PageSpecSuggestion[];
}

export interface PageSpecSuggestion {
  id: string;
  name: string;
  description: string;
  urls: string;
  spec: string;
  justification: string;
}

export interface GenerateSuggestedElementRequest {
  orgId: string;
  llmModel: LlmModel;
  method: Method;
  selector: string;
  commit: boolean;
  /**
   * whether to auto-approve the suggestion, thus promoting it to be a configured element without user review.
   * commit must be true for this to have any effect
   */
  autoApprove: boolean;
  /** initiator for tracking - selector candidate already has been chosen. */
  initiator: Initiator | null;
  selectorTrim: SelectorTrim;
  /**
   * Whether to ignore existing user configured elements, thus running suggestions which conflict with the existing configuration.
   * This setting is experimental — commit must be false to prevent saving conflicting results.
   */
  ignoreExistingElements: boolean;
}

export interface GenerateSuggestedElementResponse {
  suggestion: search_settings.Suggestion | null;
}

export interface Initiator {
  initiatorVolume?: InitiatorVolume | null;
  initiatorErrors?: InitiatorErrors | null;
  initiatorProgressIndicators?: InitiatorProgressIndicators | null;
  initiatorRecentMlPages?: InitiatorRecentMLPages | null;
  initiatorSvg?: InitiatorSvg | null;
  initiatorPowerUsers?: InitiatorPowerUsers | null;
  initiatorSuggestiveErrors?: InitiatorSuggestiveErrors | null;
  initiatorSuggestiveProgressIndicators?: InitiatorSuggestiveProgressIndicators | null;
}

export namespace Initiator {
  export enum initiator {
    initiatorVolume = 1,
    initiatorErrors = 2,
    initiatorProgressIndicators = 3,
    initiatorRecentMlPages = 4,
    initiatorSvg = 5,
    initiatorPowerUsers = 6,
    initiatorSuggestiveErrors = 7,
    initiatorSuggestiveProgressIndicators = 8
  }

  export function initiator_oneof(m: Initiator): { opt: initiator.initiatorErrors, val: InitiatorErrors } | { opt: initiator.initiatorPowerUsers, val: InitiatorPowerUsers } | { opt: initiator.initiatorProgressIndicators, val: InitiatorProgressIndicators } | { opt: initiator.initiatorRecentMlPages, val: InitiatorRecentMLPages } | { opt: initiator.initiatorSuggestiveErrors, val: InitiatorSuggestiveErrors } | { opt: initiator.initiatorSuggestiveProgressIndicators, val: InitiatorSuggestiveProgressIndicators } | { opt: initiator.initiatorSvg, val: InitiatorSvg } | { opt: initiator.initiatorVolume, val: InitiatorVolume } | null {
    if (m.initiatorVolume != null) { return { opt: initiator.initiatorVolume, val: m.initiatorVolume } }
    if (m.initiatorErrors != null) { return { opt: initiator.initiatorErrors, val: m.initiatorErrors } }
    if (m.initiatorProgressIndicators != null) { return { opt: initiator.initiatorProgressIndicators, val: m.initiatorProgressIndicators } }
    if (m.initiatorRecentMlPages != null) { return { opt: initiator.initiatorRecentMlPages, val: m.initiatorRecentMlPages } }
    if (m.initiatorSvg != null) { return { opt: initiator.initiatorSvg, val: m.initiatorSvg } }
    if (m.initiatorPowerUsers != null) { return { opt: initiator.initiatorPowerUsers, val: m.initiatorPowerUsers } }
    if (m.initiatorSuggestiveErrors != null) { return { opt: initiator.initiatorSuggestiveErrors, val: m.initiatorSuggestiveErrors } }
    if (m.initiatorSuggestiveProgressIndicators != null) { return { opt: initiator.initiatorSuggestiveProgressIndicators, val: m.initiatorSuggestiveProgressIndicators } }
    return null;
  }
}

export interface GenerateSelectorCandidatesRequest {
  orgId: string;
  initiators: GenerateSelectorCandidatesRequest.InitiatorConfig[];
  isMobile: boolean;
}

export namespace GenerateSelectorCandidatesRequest {
  export interface InitiatorConfig {
    initiator: Initiator | null;
    count: number;
  }
}

export interface GenerateSelectorCandidatesResponse {
  results: GenerateSelectorCandidatesResponse.InitiatorResult[];
}

export namespace GenerateSelectorCandidatesResponse {
  export interface InitiatorResult {
    initiator: Initiator | null;
    selectors: string[];
  }
}

export interface KickstartSuggestedElementsForAllOrgsRequest {
  commit: boolean;
  /**
   * setting stagger to true will only run some percentage of orgs based on the
   * time.
   */
  stagger: boolean;
}

export interface KickstartPageGenerationForAllOrgsRequest {
  commit: boolean;
  /**
   * setting stagger to true will only run some percentage of orgs based on the
   * time.
   */
  stagger: boolean;
}

export interface KickstartSuggestedElementsRequest {
  orgId: string;
  commit: boolean;
}

export interface SetSuggestedGenerationStatusRequest {
  orgId: string;
  status: GenerationStatus;
  /** feature to set the status for, if not provided, will default to Elements */
  feature: SuggestionFeature;
}

export interface GetSuggestedGenerationStatusRequest {
  orgId: string;
}

export enum GenerationStatus {
  GENERATIONSTATUS_UNKNOWN = 0,
  /** Suggestions are ready to be generated by the cron or by the user */
  GENERATIONSTATUS_READY = 1,
  /** Suggestions are currently being generated for the current org */
  GENERATIONSTATUS_GENERATING = 2,
  /**
   * A task has been queued for suggestions to be generated. This is only used
   * by the client to prevent further FSTA-initiated runs
   */
  GENERATIONSTATUS_TASK_QUEUED = 3,
  /**
   * From the recent run, there have been too many rejections or no results, so
   * suggestions are not currently available
   */
  GENERATIONSTATUS_NONE_FOUND = 4
}

export interface GetSuggestedGenerationStatusResponse {
  /** element generation status */
  generationStatus: GenerationStatus;
  lastUpdated: protobuf.timestamp | null;
  attributeStatus: GenerationStatus;
  attributeLastUpdated: protobuf.timestamp | null;
  mlPageSpecStatus: GenerationStatus;
  mlPageSpecLastUpdated: protobuf.timestamp | null;
  pageStatus: GenerationStatus;
  pageLastUpdated: protobuf.timestamp | null;
}

export interface HandleElementGenerationRequest {
  orgId: string;
  commit: boolean;
}

export interface HandleElementGenerationResponse {
  suggestions: search_settings.Suggestion[];
}

export enum SuggestionFeature {
  SUGGESTIONFEATURE_INVALID = 0,
  SUGGESTIONFEATURE_ELEMENTS = 1,
  SUGGESTIONFEATURE_ATTRIBUTES = 2,
  SUGGESTIONFEATURE_ML_PAGE_SPECS = 3,
  SUGGESTIONFEATURE_PAGES = 4
}

export interface KickstartSuggestionsForAllOrgsRequest {
  commit: boolean;
  /**
   * setting stagger to true will only run some percentage of orgs based on the
   * time.
   */
  stagger: boolean;
  features: SuggestionFeature[];
}

export interface HandleAttributeGenerationRequest {
  orgId: string;
  commit: boolean;
}

export interface HandleAttributeGenerationResponse {
  suggestions: AttributeSuggestion[];
}

export interface Metadata {
  /** When this entity was last updated. */
  updatedAt: protobuf.timestamp | null;
  /** When this entity was first created. */
  createdAt: protobuf.timestamp | null;
}

export interface AttributeSuggestionRecord {
  suggestion: AttributeSuggestion | null;
  metadata: Metadata | null;
}

export interface SetAttributeSuggestionRequest {
  orgId: string;
  suggestion: AttributeSuggestion | null;
}

export interface SetAttributeSuggestionResponse {
  suggestion: AttributeSuggestionRecord | null;
}

export interface GetAllAttributeSuggestionsRequest {
  orgId: string;
  priorities: Priority[];
}

export interface GetAllAttributeSuggestionsResponse {
  suggestions: AttributeSuggestionRecord[];
}

export interface GeneratePageSuggestionsRequest {
  orgId: string;
  numUrls: number;
  timeRange: segment.TimeRange | null;
  commit: boolean;
  maxPending: number;
  /** Setting true will prevent urls related to ML pages from being filtered out when fetching urls */
  includeMlPageUrls: boolean;
  /** AI judged pages with a score below this will be auto rejected */
  scoreThreshold: number;
  userConfig: PageGenUserConfig | null;
  /** @deprecated */
  includeThumbnails: boolean;
  thumbnailsPerSuggestion: number;
}

export interface PageGenUserConfig {
  language: Language;
  namingStyle: NamingStyle;
}

/** Gemini Vertex AI supported languages https://cloud.google.com/vertex-ai/generative-ai/docs/models#language_support */
export enum Language {
  UNSPECIFIED = 0,
  /** ar */
  ARABIC = 1,
  /** bn */
  BENGALI = 2,
  /** bg */
  BULGARIAN = 3,
  /** zh (Simplified) */
  CHINESE = 4,
  /** hr */
  CROATIAN = 5,
  /** cs */
  CZECH = 6,
  /** da */
  DANISH = 7,
  /** nl */
  DUTCH = 8,
  /** en */
  ENGLISH = 9,
  /** et */
  ESTONIAN = 10,
  /** fi */
  FINNISH = 11,
  /** fr */
  FRENCH = 12,
  /** de */
  GERMAN = 13,
  /** el */
  GREEK = 14,
  /** iw */
  HEBREW = 15,
  /** hu */
  HUNGARIAN = 17,
  /** id */
  INDONESIAN = 18,
  /** it */
  ITALIAN = 19,
  /** ja */
  JAPANESE = 20,
  /** ko */
  KOREAN = 21,
  /** lv */
  LATVIAN = 22,
  /** lt */
  LITHUANIAN = 23,
  /** no */
  NORWEGIAN = 24,
  /** pl */
  POLISH = 25,
  /** pt */
  PORTUGUESE = 26,
  /** ro */
  ROMANIAN = 27,
  /** ru */
  RUSSIAN = 28,
  /** sr */
  SERBIAN = 29,
  /** sk */
  SLOVAK = 30,
  /** sl */
  SLOVENIAN = 31,
  /** es */
  SPANISH = 32,
  /** sw */
  SWAHILI = 33,
  /** sv */
  SWEDISH = 34,
  /** th */
  THAI = 35,
  /** tr */
  TURKISH = 36,
  /** uk */
  UKRAINIAN = 37,
  /** vi */
  VIETNAMESE = 38
}

export enum NamingStyle {
  UNSET = 0,
  CONCISE = 1,
  DESCRIPTIVE = 2
}

export interface GeneratePageSuggestionsResponse {
  suggestions: pages.PageSuggestion[];
}

export interface PageSuggestionRecord {
  suggestion: pages.PageSuggestion | null;
  metadata: Metadata | null;
}

export interface SetPageSuggestionRequest {
  orgId: string;
  suggestion: pages.PageSuggestion | null;
}

export interface SetPageSuggestionResponse {
  suggestion: PageSuggestionRecord | null;
}

export interface GetAllPageSuggestionsRequest {
  orgId: string;
  priorities: pages.SuggestionPriority[];
  statuses: pages.SuggestionStatus[];
}

export interface GetAllPageSuggestionsResponse {
  suggestions: PageSuggestionRecord[];
}

export interface HandlePageGenerationRequest {
  orgId: string;
  commit: boolean;
  timeRange: segment.TimeRange | null;
}

export interface HandlePageGenerationResponse {
  suggestions: pages.PageSuggestion[];
}

export interface GetPageSuggestionRequest {
  orgId: string;
  suggestionId: string;
}

export interface GetPageSuggestionResponse {
  suggestion: PageSuggestionRecord | null;
}

export interface GenerateSessionPageSuggestionsRequest {
  orgId: string;
  sessionId: protobuf.int64;
  commit: boolean;
  timeRange: segment.TimeRange | null;
  /** AI judged pages with a score below this will be auto rejected */
  scoreThreshold: number;
  /** @deprecated */
  includeThumbnails: boolean;
  thumbnailsPerSuggestion: number;
}

export interface GenerateSessionPageSuggestionsResponse {
  suggestions: pages.PageSuggestion[];
}

export interface UpdatePageSuggestionsStatusesRequest {
  orgId: string;
  ids: string[];
  status: pages.SuggestionStatus;
}

export interface UpdatePageSuggestionsStatusesResponse {
  ids: string[];
}

export interface GetPageSuggestionsByIdsRequest {
  orgId: string;
  suggestionIds: string[];
}

export interface GetPageSuggestionsByIdsResponse {
  suggestions: PageSuggestionRecord[];
}

export interface RefreshPageSuggestionsThumbnailsRequest {
  orgId: string;
  suggestionIds: string[];
  thumbnailsPerSuggestion: number;
}

export interface RefreshPageSuggestionsThumbnailsResponse {
  suggestionIds: string[];
}

export interface GetPageSuggestionsThumbnailUrlsRequest {
  orgId: string;
  suggestionIds: string[];
  maxUrlsPerSuggestion: number;
}

export interface SignedThumbnailUrl {
  signedUrl: string;
  pageArgs: pages.PageArgs | null;
}

export interface PageSuggestionsThumbnailUrlMap {
  /**
   * Deprecated, use urls repeated field
   * 
   * @deprecated
   */
  url: string;
  suggestionId: string;
  signedUrls: SignedThumbnailUrl[];
}

export interface GetPageSuggestionsThumbnailUrlsResponse {
  thumbnailsUrls: PageSuggestionsThumbnailUrlMap[];
}
